module.exports = __webpack_public_path__ + "img/ce.24eb0503.png";